import React from "react";
import { Typography, Box, Button, Chip, Divider } from "@mui/material";
import Card from "@mui/material/Card";
import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
import CardMedia from "@mui/material/CardMedia";
import { useNavigate } from "react-router-dom";
import RouteConstants from "../constants/RouteConstant";
import Price1 from "../assets/price1.png";
import Vector from "../assets/Vector.png";
import { borderTop } from "@mui/system";

export const Pricing = () => {
	const navigate = useNavigate();
	const handlePayment = (price) => {
		navigate(RouteConstants.PAYMENT_GATEWAY, {
			state: { amount: price, type: "unlimited", cart: [] },
		});
	};

	return (
		<Box
			sx={{
				display: "flex",
				flexDirection: "column",
				width: { xs: "300px", md: "1280px" },
				zIndex: 3,
				p: "20px 20px",
				gap: 4,
				background: "#F8FAFC",
				// width: "1376px",
				justifyContent: "center",
				alignItems: "center",
				alignSelf: "center",
				alignContent: "center",
				py: 2,
			}}
		>
			<Box
				sx={{
					display: "flex",
					flexDirection: "column",
					justifyContent: "center",
					alignContent: "center",
					textAlign: "center",
					alignItems: "center",
				}}
			>
				<Chip
					label="Pricing"
					variant="filled"
					sx={{
						borderRadius: 4,
						fontSize: "18px",
						color: "#667085",
						width: "200px",
					}}
				/>
				<Box
					sx={{
						display: "flex",
						flexDirection: { xs: "column", md: "row" },
						justifyContent: "space-between",
						gap: { xs: 1, md: 4 },
						p: { xs: 0, md: 4 },
						// width: "1280px",
					}}
				>
					<Box width={"50%"}>
						<Typography
							fontWeight={600}
							fontSize={{ xs: 29, md: 48 }}
							color="#000000"
							width={{ xs: 290, md: 455 }}
							textAlign={{ xs: "center", md: "left" }}
						>
							{"Simple Pricing, Maximum Value"}
						</Typography>
					</Box>
					<Box width={{ xs: "100%", md: "50%" }}>
						<Card
							sx={{
								width: { xs: 290, md: 634 },
								height: { xs: "auto", md: 280 },
								// gap: 2,
								display: "flex",
								flexDirection: "column",
								// p: 2,
								borderRadius: 4,
							}}
						>
							<Box
								sx={{
									height: 90,
									width: { xs: 290, md: 634 },

									display: "flex",
									justifyContent: "center",
									alignItems: "center",
									bgcolor: "secondary.main",
								}}
							>
								<Typography
									fontWeight={600}
									fontSize={{ xs: 15, md: 15 }}
									color="primary.main"
									alignContent={"center"}
									textTransform={"uppercase"}
								>
									{"premium Access"}
								</Typography>
							</Box>
							<Box display={"flex"} flexDirection={{ xs: "column", md: "row" }}>
								<Box width={{ xs: "100%", md: "50%" }}>
									<CardMedia
										sx={{
											height: { xs: 154, md: 150 },
											width: { xs: 154, md: 154 },

											mt: 2,
											mr: { xs: "-23px", md: "-27px" },
											ml: { xs: "10px", md: "38px" },
										}}
										image={Price1}
										title="green iguana"
									/>
								</Box>
								<Divider sx={{ dispaly: { xs: "block", md: "none" }, mx: 3 }} />
								<Divider
									orientation="vertical"
									flexItem
									sx={{ dispaly: { xs: "none", md: "flex" }, my: 3 }}
								/>
								<Box
									width={{
										xs: "100%",
										md: "50%",
									}}
								>
									<CardContent
										sx={{
											display: "flex",
											flexDirection: "column",
											gap: 2,
											mt: { xs: 3, md: 5 },
										}}
									>
										<Typography
											gutterBottom
											variant="h5"
											component="div"
											fontSize={"16px"}
											height={"24px"}
											textAlign={"center"}
											color={"#3F486A"}
											px={2}
											sx={{ display: "flex", flexDirection: "row", gap: 2 }}
										>
											<Box component={"img"} height={17} src={Vector} />
											{"50 Instant Reports"}
										</Typography>
										<Typography
											gutterBottom
											variant="h5"
											component="div"
											fontSize={"16px"}
											height={"24px"}
											textAlign={"center"}
											color={"#3F486A"}
											px={2}
											sx={{ display: "flex", flexDirection: "row", gap: 2 }}
										>
											<Box component={"img"} height={17} src={Vector} />
											{"Sales Revenue"}
										</Typography>
										<Typography
											gutterBottom
											variant="h5"
											component="div"
											fontSize={"16px"}
											height={"24px"}
											textAlign={"center"}
											color={"#3F486A"}
											px={2}
											sx={{ display: "flex", flexDirection: "row", gap: 2 }}
										>
											<Box component={"img"} height={17} src={Vector} />
											{"Selling Price"}
										</Typography>
									</CardContent>
									<CardActions>
										<Button
											variant="contained"
											size="small"
											color="primary"
											sx={{
												marginTop: "1em",
												margin: "1em",
												bgcolor: "tertiary.main",
												color: "primary.main",
												borderRadius: 8,
												height: "42px",
												width: "243px",
											}}
											onClick={() => {
												handlePayment(1);
											}}
										>
											{"Subscribe Now "}
										</Button>
									</CardActions>
								</Box>
							</Box>
						</Card>
					</Box>
				</Box>
			</Box>
		</Box>
	);
};
